import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2100186"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_4 = {
  key: 1,
  class: "flex p-2 text-red-700"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "pl-2" }

import axios from 'axios'
import { computed, ref } from 'vue'
import { ENVIRONMENT, UI_PAYMENT_ELEMENT_EVENT } from '@/helper/constants'
import { extractAPIErrorMsg } from '@/helper/index'
import { UIContentWrap, UIButton } from '@gohighlevel/ghl-ui'
import { UIPaymentElement } from '@gohighlevel/ghl-payment-element'
import PaymentWarningIcon from '@/assets/payment-warning.svg'
import { v4 as uuidv4 } from 'uuid'
import UISpinner from '../common/UISpinner.vue'
import config from '../../config'
import Recaptcha from './captcha/Recaptcha.vue'
import { STRIPE_PAYMENT_CONFIGURATION_LIVE, STRIPE_PAYMENT_CONFIGURATION_TEST } from '@/helper/constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentV2',
  props: {
  size: String,
  locationId: String,
  contactId: String,
  sourceId: String, // offer id
  priceIds: String,
  purchaseV2: Function,
  isLivePayment: Boolean,
  offer: Object,
  closeModal: Function,
  couponData: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props, { expose: __expose }) {

const props = __props

const isProcessingOrder = ref(false)
const isProcessingPayment = ref(false)
const isPaymentElementReady = ref(false)
const errorMsg = ref()
const paymentElementOptions = ref()
const paymentElementRef = ref()
const isLivePayment = ref(props.isLivePayment)
const showRecaptcha = ref(false)
const reCaptchaToken = ref(undefined)
const reCaptchaError = ref('')
const orderData = ref<any>(null)

const paymentMode = computed(() => {
  return process.env.NODE_ENV == 'production' ? 'production' : 'staging'
})

const stripeOptions = computed(() => {
  const { amount, currency, type, trialDays, setupFee } = props.offer

  const currencyLower = currency.toLowerCase()

  if (type === 'subscription') {
    if (trialDays && Number(trialDays) > 0) {
      if (setupFee && Number(setupFee) > 0) {
        return {
          mode: 'subscription',
          amount: setupFee,
          currency: currencyLower,
          paymentMethodConfiguration: props.isLivePayment ? STRIPE_PAYMENT_CONFIGURATION_LIVE : STRIPE_PAYMENT_CONFIGURATION_TEST
        }
      } else {
        return {
          mode: 'payment',
          amount: 0,
          currency: currencyLower,
          paymentMethodConfiguration: props.isLivePayment ? STRIPE_PAYMENT_CONFIGURATION_LIVE : STRIPE_PAYMENT_CONFIGURATION_TEST
        }
      }
    } else {
      return {
        mode: 'subscription',
        amount: Number(amount) + Number(setupFee ? setupFee : 0),
        currency: currencyLower,
        paymentMethodConfiguration: props.isLivePayment ? STRIPE_PAYMENT_CONFIGURATION_LIVE : STRIPE_PAYMENT_CONFIGURATION_TEST
      }
    }
  }
  const { couponData } = props

  return {
    mode: 'payment',
    amount: couponData?.isValidCode ? couponData.total : amount,
    currency: currencyLower,
    paymentMethodConfiguration: props.isLivePayment ? STRIPE_PAYMENT_CONFIGURATION_LIVE : STRIPE_PAYMENT_CONFIGURATION_TEST
  }
})

const setErrorMsg = (msg: string) => {
  errorMsg.value = msg
}

const onPaymentCallback = (event) => {
  if (event.type === UI_PAYMENT_ELEMENT_EVENT.READY) {
    isPaymentElementReady.value = event.value
  } else if (event.type === UI_PAYMENT_ELEMENT_EVENT.PROCESSING) {
    setErrorMsg('')
    isProcessingPayment.value = event.value
  } else if (event.type === UI_PAYMENT_ELEMENT_EVENT.ERROR) {
    if (event.message === 'Request failed with status code 429') {
      showRecaptcha.value = true
    } else {
      setErrorMsg(event.message)
    }
    isProcessingPayment.value = false
  } else if (event.type === UI_PAYMENT_ELEMENT_EVENT.SUCCESS) {
    setErrorMsg('')
    isProcessingPayment.value = false
    paymentElementOptions.value = undefined
    isPaymentElementReady.value = false
    props.purchaseV2({
      ...event.data,
      orderId: orderData.value ? orderData.value?._id : event.data.orderId,
    })
  }
}

const onVerify = (response: any) => {
  if (!response) {
    reCaptchaError.value = 'Verification failed! Please try again'
    return
  }
  reCaptchaError.value = ''
  reCaptchaToken.value = response
}

const closeModal = () => {
  props.closeModal()
}

__expose({
  processPayment,
})

async function placeOrder() {
  if (isProcessingOrder.value) return
  isProcessingOrder.value = true
  setErrorMsg('')
  try {
    const requestURL = `${config.paymentBaseUrl}/orders`
    const { locationId, contactId, sourceId, priceIds, offer, couponData } =
      props

    const requestBody = {
      altId: locationId,
      altType: 'location',
      contactId: contactId,
      source: {
        type: 'membership',
        id: sourceId, // offer id
        name: `${
          offer?.title ? offer?.title : `${locationId}:${contactId}`
        } - Payment`,
      },
      products: priceIds
        .split(',')
        .map((id) => ({
          id: id.trim(),
          qty: 1,
        }))
        .filter((product) => product.id),
      fingerprint: uuidv4(),
      trackingId: uuidv4(),
      captchaToken: reCaptchaToken.value,
    }

    if (couponData?.isValidCode) {
      requestBody.couponCode = couponData?.code
      requestBody.couponSessionId = uuidv4()
    }

    const { data } = await axios.post(requestURL, requestBody)
    orderData.value = data && data.order ? data.order : {}

    return data
  } catch (error) {
    if (error?.response?.status === 429) {
      return { reprocess: true }
    }
    const errorMsg = extractAPIErrorMsg(error)
    setErrorMsg(errorMsg)
  } finally {
    isProcessingOrder.value = false
  }
}

async function processPayment() {
  const isValid = await paymentElementRef.value.validatePayment()
  if (!isValid) return
  const { order, reprocess } = await placeOrder()
  reCaptchaToken.value = undefined
  if (reprocess) {
    showRecaptcha.value = true
    isProcessingOrder.value = false
    return
  }
  if (order._id) {
    const sourceParams = {
      source: 'order',
      sourceId: order._id,
      traceId: order.traceId,
      captchaToken: reCaptchaToken.value,
    }
    await paymentElementRef.value.confirmPayment(sourceParams)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (!isPaymentElementReady.value && !errorMsg.value)
            ? (_openBlock(), _createBlock(UISpinner, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_unref(UIPaymentElement), {
            ref_key: "paymentElementRef",
            ref: paymentElementRef,
            env: paymentMode.value,
            id: "payment-element",
            altId: __props.locationId,
            altType: "location",
            liveMode: isLivePayment.value,
            debug: false,
            showModeBadge: true,
            stripeOptions: stripeOptions.value,
            onPaymentCallback: onPaymentCallback
          }, null, 8, ["env", "altId", "liveMode", "stripeOptions"])
        ])
      ]),
      (showRecaptcha.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(Recaptcha, {
              onExpired: _cache[0] || (_cache[0] = () => (reCaptchaToken.value = undefined)),
              onVerify: onVerify
            }),
            (reCaptchaError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(reCaptchaError.value), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (errorMsg.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(PaymentWarningIcon),
              alt: "alert"
            }, null, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, _toDisplayString(errorMsg.value), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})